var map = {
	"./de_CH.json": 9684,
	"./de_DE.json": 52796,
	"./en_EN.json": 20656,
	"./es_ES.json": 40470,
	"./fi_FI.json": 86232,
	"./fr_FR.json": 10038,
	"./it_IT.json": 20856,
	"./sl_SI.json": 14999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84649;